export default __webpack_public_path__ + "static/media/BannerMobile.8e2d4376.png";